var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveViewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 4C21.5 3.17157 20.8284 2.5 20 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V20C2.5 20.8284 3.17157 21.5 4 21.5H20C20.8284 21.5 21.5 20.8284 21.5 20V4ZM4 4H8.69686L7.16043 5.75H4V4ZM4 7.25V16.75H20V7.25H13.9115C13.9089 7.25001 13.9063 7.25001 13.9038 7.25H7.50357C7.50099 7.25001 7.49841 7.25001 7.49584 7.25H4ZM9.15651 5.75H13.5684L15.1048 4H10.6929L9.15651 5.75ZM15.5644 5.75H20V4H17.1009L15.5644 5.75ZM17.0145 18.25H20V20H15.4781L17.0145 18.25ZM10.6066 18.25H15.0184L13.482 20H9.07016L10.6066 18.25ZM4 18.25H8.61052L7.07408 20H4V18.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3419 12.5391C15.2644 12.6596 15.162 12.762 15.0415 12.8395L10.8907 15.5078C10.4262 15.8065 9.80746 15.672 9.50881 15.2074C9.40512 15.0461 9.34999 14.8584 9.34999 14.6667V9.32999C9.34999 8.7777 9.79771 8.32999 10.35 8.32999C10.5417 8.32999 10.7295 8.38512 10.8907 8.48881L15.0415 11.1571C15.5061 11.4558 15.6406 12.0745 15.3419 12.5391ZM13.577 11.9983L10.85 10.2453V13.7503L13.577 11.9983Z",
    fill: "#3BC2C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveViewActive);
export default __webpack_public_path__ + "static/media/liveViewActive.594f92d81b7e34a7faad04e285b27240.svg";
export { ForwardRef as ReactComponent };